import { useMemo } from 'react';

import { UnifiedProfilesProvider } from './UnifiedProfilesContext.jsx';

/**
 * Composes the domain's shared state into one memoized context value.
 *
 * Empty for now: the list and profile screens each own their own query
 * (CT-5277 / CT-5282). State only moves here when two screens genuinely need
 * to share it — lifting it early would couple them for nothing.
 */
function UnifiedProfilesProviderWrapper({ children }) {
  const value = useMemo(() => ({}), []);

  return <UnifiedProfilesProvider value={value}>{children}</UnifiedProfilesProvider>;
}

export default UnifiedProfilesProviderWrapper;
